import { FC } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { injectIntl, IntlShape } from 'react-intl';
import {
  VictimContainer,
  Header,
  Content,
  VictimTitle,
  InputField,
} from 'containers/ExpertExpertise/Victim/style';
import VictimIconBlack from 'components/SahamIcons/VictimIconBlack';
import { translate } from 'containers/services/translate';
import messages from 'containers/ExpertExpertise/Vehicle/messages';
import { VehicleType } from 'containers/ExpertExpertise/Vehicle/typings';
import { getCity } from 'containers/RecapManagerPage/utils';

export interface VehicleProps {
  intl: IntlShape;
  vehicle: VehicleType;
  courtFileNumber: string;
  expertiseDate: string;
  missionReference: string;
}

const Vehicle: FC<VehicleProps> = props => {
  const { vehicle, courtFileNumber, expertiseDate, missionReference } = props;
  const cities = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings', 'villes'], []),
  );
  return (
    <VictimContainer>
      <Header>
        <VictimIconBlack />
        <VictimTitle>{translate(messages.vehicle, props)}</VictimTitle>
      </Header>
      <Content>
        <InputField
          label={translate(messages.reference, props)}
          defaultValue={missionReference}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.courtFileNumber, props)}
          defaultValue={courtFileNumber}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.registrationNumber, props)}
          defaultValue={get(vehicle, 'registrationNumber', '')}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.lastName, props)}
          defaultValue={get(vehicle, 'lastName', '')}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.firstName, props)}
          defaultValue={get(vehicle, 'firstName', '')}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.expertiseDate, props)}
          defaultValue={expertiseDate}
          InputProps={{
            readOnly: true,
          }}
        />
        <InputField
          label={translate(messages.city, props)}
          defaultValue={getCity(cities, vehicle?.city)?.ItemDescription}
          InputProps={{
            readOnly: true,
          }}
        />
      </Content>
    </VictimContainer>
  );
};

export default injectIntl(Vehicle);
